import React from "react";
import styled from "styled-components";

export default function ReportControlBar({ children, style, className }) {
  return <Bar style={style} className={className}>{children}</Bar>;
}

const Bar = styled.div`
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 16px;
  padding: 12px 16px;
  margin-bottom: 16px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.04);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    padding: 10px 12px;
    gap: 10px;
  }
`;
